import {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {Col, Row, Space, Spin} from "antd";

export function RedirectQRPage() {
    const { qrCodeId } = useParams();
    const navigate = useNavigate();
    const [error, setError] = useState(false);

    useEffect(() => {
        const resolveQrAndRedirect = async () => {
            try {
                const domain = window.location.host;

                const response = await fetch("https://api.servitecperu.com/qr-codes/resolve", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        domain: domain,
                        qrId: qrCodeId,
                    }),
                });

                const data = await response.json();

                if (data.success && data.destinationUrl) {
                    window.location.href = data.destinationUrl;
                } else {
                    setError(true);
                    navigate("/404", { replace: true });
                }
            } catch (err) {
                console.error("「Client Redirect Error」", err);
                setError(true);
                navigate("/", { replace: true });
            }
        };

        if (qrCodeId) {
            resolveQrAndRedirect();
        }
    }, [qrCodeId, navigate]);

    return (
        <Row justify="center" align="middle" style={{ minHeight: "100vh", background: "#000000" }}>
            <Col style={{ textAlign: "center" }}>
                {!error && (
                    <Space direction="vertical" size="middle">
                        <Spin size="large" />
                        <span style={{ color: "#A0A0A0", fontSize: "14px", display: "block" }}>
              Redireccionando...
            </span>
                    </Space>
                )}
            </Col>
        </Row>
    );
}